"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GhostButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("./Button");
const GhostButton = (props) => {
    return ((0, jsx_runtime_1.jsx)(Button_1.Button, Object.assign({}, props, { background: "transparent" })));
};
exports.GhostButton = GhostButton;
